import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'visibleInConnect',
    standalone: false
})
export class VisibleInConnectPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(value: boolean, ...args: unknown[]): unknown {
        if (value != null) {
            return value
                ? this.translateService.instant('Shared.VisibleInConnect')
                : this.translateService.instant('Shared.HiddenInConnect');
        }

        return null;
    }
}
